module.exports = __webpack_public_path__ + "img/OLDGOD Mini.d5b4b4c9.svg";